export default __webpack_public_path__ + "static/media/add-icon.1654320c.svg";